var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from 'react';
import IconContainer, { IconSVG } from './IconContainer';
var IconHistoryForward = React.memo(function (props) {
    var color = props.color, rest = __rest(props, ["color"]);
    return (React.createElement(IconContainer, __assign({}, rest),
        React.createElement(IconSVG, { color: color, inheritColor: props.inheritColor, fill: "none", x: "0px", y: "0px", viewBox: "0 0 30 30", strokeLinejoin: "round", strokeLinecap: "round" },
            React.createElement("g", { transform: "translate(-59.832 -758.41)" },
                React.createElement("g", { transform: "translate(59.843 756.24)" },
                    React.createElement("path", { d: "M25.8,8.5V15h-6.5" }),
                    React.createElement("path", { d: "M23.1,20.4c-1.8,5.1-7.4,7.7-12.4,6s-7.7-7.4-6-12.4s7.4-7.7,12.4-6c1.4,0.5,2.6,1.3,3.6,2.3\n\t\t\tl5,4.7" })),
                React.createElement("g", { transform: "translate(57.833 758.333)" },
                    React.createElement("path", { d: "M15.3,10.3v6l4,2" }))))));
});
export default IconHistoryForward;
//# sourceMappingURL=IconHistoryForward.js.map